const FORMATS = {
    DATE_TIME: "DD/MM/YYYY, HH:mm"
}

export default FORMATS;